import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { NgForm } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { isNil } from 'lodash';
import { CommonModule } from '@angular/common';
import { REMOVED, TestSetupModule } from '@nrwl/test-setup';
import { CommonMaterialModule } from '@nrwl/common-material';
import {
  SchedulerComponent,
  DevicesService,
  CommonRegEx,
  SchedulerFormat,
  NotificationService,
  LicensesPageService,
  CommonLibModule,
  AGENT_MODEL,
  TestMode
} from '@nrwl/common-lib';
import {
  BaseSetupTab,
  IComponentStateHistory,
  IValueChangedEvent,
  outputParams
} from '@nrwl/test-setup';
import {
  UDPConfigFieldMapping as ConfigFieldMapping,
  DEFAULT_STREAM_A2B,
  DEFAULT_STREAM_B2A,
  STREAM_RATE_TYPE,
  TEST_DURATIONS,
  VLAN_TYPE_SELECTION
} from '../../models/models';
import { UdpSetupService } from '../../udp-setup.service';
import { takeUntil } from 'rxjs/operators';
import { ScheduleLicense } from '@nrwl/licenses';
import { cloneDeep } from 'lodash';
@Component({
  selector: 'nrwl-udp-setup',
  standalone: true,
  imports: [CommonModule, TestSetupModule, CommonMaterialModule, FormsModule, CommonLibModule],
  templateUrl: './udp-setup.component.html',
  styleUrls: ['./udp-setup.component.scss']
})
export class UdpSetupComponent implements OnInit, OnDestroy {
  @Input() tab: BaseSetupTab;
  @Input() setupCtrl: any;
  @Input() componentId: string;
  @Input() stateHistory?: IComponentStateHistory;
  @Input() otherTabStateHistory: IComponentStateHistory;
  //eslint-disable-next-line
  @Input() restoreValues?: Function;
  //eslint-disable-next-line
  @Input() restoreAgentBasedConfig?: Function;
  @Input() previousOutput: outputParams;
  //eslint-disable-next-line
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onOtherTabDataValueChange = new EventEmitter<any>();
  @ViewChild('setupForm', { static: true }) form: NgForm;
  @ViewChild(SchedulerComponent) schedulerChild: SchedulerComponent;

  private tabsubscription: Subscription;
  configMapping = ConfigFieldMapping;
  newTestMode = true;
  customerName = '';
  technicianName = '';
  contact = '';
  email = '';
  phone = '';
  technicianId = '';
  comments = '';
  testName = 'UDP';
  editMode = false;
  cloneMode = false;
  showDirections = true;
  testInfo: any;
  config: any;
  outputs: Array<string>;
  selectedOriginator: any;
  selectedDestination: any;
  agentType: string;
  testMode: string;
  direction: string;
  customScheduleEnds: any;
  testDurationOptions = TEST_DURATIONS;
  streamRateTypes = STREAM_RATE_TYPE;
  vlanTypeSelection = VLAN_TYPE_SELECTION;
  expirationDefaultValue = null;
  defaultExpirationTime: number = null;
  defaultExecCount = null;
  showExecutionCountField = false;
  showExpirationField = false;
  executionCountsOverwrite = true;
  expirationTimeOverwrite = true;
  maxExecutionCountValue = 100;
  customDuration = 900;
  expireTimeData: Array<{ name: string; value: string }> = [];
  expirationTimeIntervalList = [0, 1, 2, 6, 12, 24, 36, 168];
  validTestDurationRegex: RegExp = CommonRegEx.HH_MM_SS_REGEX;
  addingColonTwoCharRegex: RegExp = CommonRegEx.COLON_TWO_CHARACTORS;
  formField = {
    testDuration: null,
    customTestDuration: null,
    streamRateConvention: null,
    vlan: null,
    expirationTime: null,
    executionCounts: null
  };
  scheduler: SchedulerFormat;
  scheduleInfoData: SchedulerFormat = {
    repeatInterval: 0,
    timeStamp: '',
    endTime: '',
    isValid: true
  };
  isDisabledScheduler = false;
  schedulerEnds = {
    enabled: false,
    optionsList: TEST_DURATIONS
  };
  srcAgentType: string;
  udpScheduleLicense = ScheduleLicense.UDP;
  streamsA2B = [];
  streamsB2A = [];
  isvalidCustomDuration = true;
  customDurationErrorMsg = null;
  formTooltip = {
    maxExecutionCounts:
      'Specify the maximum execution count of this test. The range of count is between 0 and 100, or Unlimited. 0 means Unlimited. This range is configured at the server.'
  };

  readonly unsubscribe: Subject<void> = new Subject();
  constructor(
    private readonly licenseService: LicensesPageService,
    public setupService: UdpSetupService,
    private readonly deviceService: DevicesService,
    private readonly notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.tab.form = this.form;
    this.initializeData();
    if (this.setupService.tabDataChangeEvents) {
      this.tabsubscription = this.setupService.tabDataChangeEvents.subscribe(event => {
        if (event === 0) {
          this.restoreFormValues();
        }
      });
    }
    this.licenseService.activeTestLicenseDetails.subscribe(licenseData => {
      if (licenseData?.length) {
        this.isDisabledScheduler = !licenseData.some(license =>
          this.udpScheduleLicense?.includes(license.featureName)
        );
      }
    });
  }

  initializeData(): void {
    this.restoreAgentBasedConfig(null, TestMode.CLIENT_TO_MA);
    this.restoreFormValues();
    this.restoreOtherTabValues();
    this.newTestMode = this.setupService.mode === 'new';
    this.editMode = this.setupService.editMode;
    this.cloneMode = this.setupService.mode === 'clone';
    if (this.setupService.controllerConfig) {
      this.setupService.controllerConfig.pipe(takeUntil(this.unsubscribe)).subscribe(response => {
        if (response.status === 'success') {
          if (this.newTestMode) {
            this.defaultExecCount = response.data.test.defaultExecCount;
            this.defaultExpirationTime = response.data.test.defaultExpTimeInterval;
          }
          this.expirationTimeIntervalList = response.data.test.expTimeList;
          this.maxExecutionCountValue =
            response.data.test.limitedMaxExecCount || response.data.test.maxExecCount;
          this.executionCountsOverwrite = response.data.test.execCountOverwrite;
          this.expirationTimeOverwrite = response.data.test.expirationTimeOverwrite;
        }
        this.restoreFormValues();
      });
    } else {
      this.restoreFormValues();
    }
    if (!this.newTestMode) {
      this.restoreAgentBasedConfig(this.srcAgentType, this.testMode);
      this.restoreFormValues();
    }
  }

  restoreFormValues(): void {
    this.testName = this.restoreFieldValues(ConfigFieldMapping.ALIAS);
    this.customerName = this.restoreFieldValues(ConfigFieldMapping.CUSTOMER);
    this.technicianName = this.restoreFieldValues(ConfigFieldMapping.TECHINICIAN);
    this.contact = this.restoreFieldValues(ConfigFieldMapping.CONTACT);
    this.email = this.restoreFieldValues(ConfigFieldMapping.EMAIL);
    this.phone = this.restoreFieldValues(ConfigFieldMapping.PHONE);
    this.technicianId = this.restoreFieldValues(ConfigFieldMapping.TECHINICIANID);
    this.comments = this.restoreFieldValues(ConfigFieldMapping.COMMENTS);
    this.testMode = this.restoreFieldValues(ConfigFieldMapping.TEST_MODE);
    this.direction = this.restoreFieldValues(ConfigFieldMapping.DIRECTION);
    this.formField.testDuration = this.restoreFieldValues(ConfigFieldMapping.TEST_DURATION);
    this.formField.customTestDuration = this.restoreFieldValues(
      ConfigFieldMapping.TEST_CUSTOM_DURATION
    );
    this.formField.streamRateConvention = this.restoreFieldValues(
      ConfigFieldMapping.STREAM_RATE_CONVENTION
    );
    this.formField.vlan = this.restoreFieldValues(ConfigFieldMapping.VLAN);
    this.formField.expirationTime = this.restoreFieldValues(ConfigFieldMapping.EXPIRATION_DATE);
    const executionCount =
      this.defaultExecCount ?? this.restoreFieldValues(ConfigFieldMapping.MAX_EXECUTION_COUNTS);
    this.formField.executionCounts = executionCount > 0 ? executionCount : null;
    this.expirationDefaultValue =
      this.defaultExpirationTime ??
      this.restoreFieldValues(ConfigFieldMapping.EXPIRATION_DEFAULT_VALUE);

    this.showExecutionCountField = !isNil(
      this.restoreFieldValues(ConfigFieldMapping.MAX_EXECUTION_COUNTS)
    );
    this.showExpirationField = !isNil(
      this.restoreFieldValues(ConfigFieldMapping.EXPIRATION_DEFAULT_VALUE)
    );
    this.restoreScheduleParams(ConfigFieldMapping.SCHEDULER);
    this.setupExpirationDateDisplay();
    this.selectedOriginator = this.restoreFieldValues(ConfigFieldMapping.SELECTED_ORIGINATOR);
    this.selectedDestination = this.restoreFieldValues(ConfigFieldMapping.SELECTED_DESTINATION);
    this.srcAgentType = this.restoreFieldValues(ConfigFieldMapping.AGENT_TYPE);
  }

  restoreScheduleParams(field: string): void {
    const data = this.stateHistory(this.componentId, field);
    if (data && data.value !== REMOVED) {
      this.populateScheduler(data.value);
    }
  }

  populateScheduler(schedulerInfo: SchedulerFormat): void {
    this.scheduleInfoData.repeatInterval = schedulerInfo.repeatInterval;
    this.scheduleInfoData.timeStamp = schedulerInfo.timeStamp;
    this.scheduleInfoData.isValid = true;
    this.emitScedulerParams();
  }

  setupExpirationDateDisplay(): void {
    if (this.expirationDefaultValue) {
      this.expireTimeData = [];
      let defaultTime = this.formField.expirationTime;
      if (this.newTestMode) {
        defaultTime = this.calculateExpirationTime(this.expirationDefaultValue);
      }
      if (this.formField.expirationTime === '3000-01-01 00:00') {
        defaultTime = 'Unlimited';
      } else {
        this.expireTimeData.push({ name: defaultTime, value: defaultTime });
      }
      this.expireTimeData.push({ name: defaultTime, value: defaultTime });
      let flagUnlimitedOption = false;
      this.expirationTimeIntervalList.forEach(interval => {
        if (interval !== 0) {
          const displayInterval = this.getDisplayIntervalForSelect(interval);
          this.expireTimeData.push({ name: displayInterval, value: interval.toString() });
        } else {
          // 0 is in Expiration Date List,will process this "Unlimited" condition at last.
          flagUnlimitedOption = true;
        }
      });
      // If Unlimited is allowed, then put the option in the end of the drop down menu.
      if (flagUnlimitedOption) {
        const displayInterval = 'Unlimited';
        this.expireTimeData.push({ name: displayInterval, value: 'unlimited' });
      }
      this.formField.expirationTime = defaultTime;
      this.onDataEmit(ConfigFieldMapping.EXPIRATION_DATE, defaultTime, true);
    }
  }

  getDisplayIntervalForSelect(interval: number): string {
    let displayInterval = '+ ' + interval;
    if (interval == 1) displayInterval += ' hr';
    else if (interval > 23) {
      const days = Math.floor(interval / 24);
      const hours = interval % 24;
      if (days == 1) displayInterval = '+ ' + days + ' day';
      else displayInterval = '+ ' + days + ' days';
      if (hours == 1) displayInterval += ' and ' + hours + ' hr';
      else if (hours > 1) displayInterval += ' and ' + hours + ' hrs';
    } else displayInterval += ' hrs';
    return displayInterval;
  }

  updateTestIdentity(event: {
    testName: string;
    customer: string;
    technician: string;
    contact: string;
    email: string;
    phone: string;
    technicianId: string;
    isValidName: boolean;
    comments: string;
  }): void {
    this.onDataEmit('alias', event.testName, event.isValidName);
    this.onDataEmit('customer', event.customer, true);
    this.onDataEmit('technician', event.technician, true);
    this.onDataEmit('contact', event.contact, true);
    this.onDataEmit('email', event.email, true);
    this.onDataEmit('phone', event.phone, true);
    this.onDataEmit('technicianId', event.technicianId, true);
    this.onDataEmit('comments', event.comments, true);
    const controls = this.form?.form?.controls;
    const allValid = controls ? Object.values(controls).every(control => !control.invalid) : true;
    const isFormValid = event.isValidName && allValid;
    this.form.form?.setErrors(isFormValid ? null : { invalid: true });
  }
  //eslint-disable-next-line
  onAgentChange(data: any): void {
    if (data.direction !== this.direction || data.testMode !== this.testMode) {
      const streamsB2A = DEFAULT_STREAM_B2A;
      if (data.direction === 'unidirectional-b2a') {
        streamsB2A[0].name = 'service 1';
      } else if (data.direction !== 'unidirectional-a2b') {
        streamsB2A[0].name = 'service 11';
      }
      this.onOtherTabDataValueChange.emit({
        componentId: 'udp.streams.html',
        key: ConfigFieldMapping.STREAMS_A2B,
        newValue: DEFAULT_STREAM_A2B,
        isValid: true
      });
      this.onOtherTabDataValueChange.emit({
        componentId: 'udp.streams.html',
        key: ConfigFieldMapping.STREAMS_B2A,
        newValue: streamsB2A,
        isValid: true
      });
      this.streamsA2B = DEFAULT_STREAM_A2B;
      this.streamsB2A = streamsB2A;
      this.onStreamRateConventionChange();
      this.onVlanChange();
    }
    if (data['engine-a-info']) {
      data['engine-a-info']['engine-type'] = 'vprobe';
    }
    if (data['engine-b-info']) {
      data['engine-b-info']['engine-type'] = 'vprobe';
    }
    this.onDataEmit(ConfigFieldMapping.ENGINE_A_INFO, data['engine-a-info'], data.isValid);
    this.onDataEmit(ConfigFieldMapping.TEST_MODE, data.testMode, true);
    this.onDataEmit(ConfigFieldMapping.DIRECTION, data.direction, true);
    this.selectedOriginator = this.deviceService.findDeviceByID(data.originatorId);
    if (this.selectedOriginator) {
      this.onDataEmit(
        ConfigFieldMapping.SELECTED_ORIGINATOR,
        this.selectedOriginator,
        data.isValid
      );
      this.agentType = this.selectedOriginator.getModel();
      this.onDataEmit('model', this.agentType, true);
      this.restoreAgentBasedConfig(this.agentType, data.testMode);
      this.restoreFormValues();
    } else if (data.testMode) {
      this.restoreAgentBasedConfig(this.agentType, data.testMode);
      this.restoreFormValues();
    }

    this.selectedDestination = this.deviceService.findDeviceByID(data.destinationId);
    if (this.selectedDestination) {
      this.onDataEmit(
        ConfigFieldMapping.SELECTED_DESTINATION,
        this.selectedDestination,
        data.isValid
      );
      this.onDataEmit(ConfigFieldMapping.ENGINE_B_INFO, data['engine-b-info'], data.isValid);
    }
    const modelAgentType =
      this.selectedOriginator?.getModel() || this.selectedDestination?.getModel();
    this.onDataEmit(ConfigFieldMapping.AGENT_TYPE, modelAgentType, true);
    this.restoreAgentBasedConfig(modelAgentType, this.testMode);
    this.restoreFormValues();
  }

  restoreFieldValues(field: string): any {
    const data = this.stateHistory(this.componentId, field);
    if (data && !isNil(data.value) && data.value !== REMOVED) {
      return data.value;
    }
    return null;
  }

  onTestDurationChange(): void {
    this.onDataEmit(ConfigFieldMapping.TEST_DURATION, this.formField.testDuration, true);
  }

  customTestDurationChange(): void {
    let duration = null;
    this.customDurationErrorMsg = null;
    this.isvalidCustomDuration = false;
    if (this.formField.testDuration === 'custom') {
      duration = this.getTimeDurationInSeconds();
      if (
        this.formField.customTestDuration.length === 8 &&
        this.formField.customTestDuration.match(this.validTestDurationRegex) &&
        duration > 0
      ) {
        this.isvalidCustomDuration = true;
        this.onDataEmit(
          ConfigFieldMapping.TEST_CUSTOM_DURATION,
          this.formField.customTestDuration,
          true
        );
        this.onDataEmit(ConfigFieldMapping.TEST_DURATION, this.formField.testDuration, true);
      } else {
        this.isvalidCustomDuration = false;
        this.customDurationErrorMsg =
          'Valid format is: HH:MM:SS where HH is 0-24, MM and SS are 0-59.  The minimum value is 1 sec, maximum is 24 hours.';
        this.onDataEmit(ConfigFieldMapping.TEST_DURATION, null, true);
      }
    }
  }
  //eslint-disable-next-line
  reformatTestDuration(event: any) {
    if (event.data && event.target.value.length < 8) {
      event.target.value = event.target.value.replace(this.addingColonTwoCharRegex, '$1:');
    }
  }

  getTimeDurationInSeconds(): number {
    let duration = this.customDuration;
    const hms = this.formField.customTestDuration.split(':');
    if (hms.length === 3) {
      const hours = parseInt(hms[0], 10);
      const minutes = parseInt(hms[1], 10);
      const seconds = parseInt(hms[2], 10);
      duration = Number(hours) * 60 * 60 + Number(minutes) * 60 + seconds;
    }
    return duration;
  }

  onStreamRateConventionChange(): void {
    this.onDataEmit(
      ConfigFieldMapping.STREAM_RATE_CONVENTION,
      this.formField.streamRateConvention,
      true
    );
    this.setupService.updateStreamTable(
      this.formField.streamRateConvention,
      this.formField.vlan,
      'convention',
      this.streamsA2B,
      this.streamsB2A
    );
  }

  onVlanChange(): void {
    this.onDataEmit(ConfigFieldMapping.VLAN, this.formField.vlan, true);
    this.setupService.updateStreamTable(
      this.formField.streamRateConvention,
      this.formField.vlan,
      'vlan',
      this.streamsA2B,
      this.streamsB2A
    );
  }
  //eslint-disable-next-line
  onExpireTimeChange($event: any): void {
    let expirationDate = '';
    if (this.formField.expirationTime !== 'unlimited') {
      expirationDate = this.calculateExpirationTime(parseInt(this.formField.expirationTime));
      this.expireTimeData[0] = { name: expirationDate, value: expirationDate };
      this.formField.expirationTime = expirationDate;
    } else {
      expirationDate = '3000-01-01 00:00';
    }
    this.onDataEmit(ConfigFieldMapping.EXPIRATION_DATE, expirationDate, true);
  }

  calculateExpirationTime(timeInterval: number): string {
    const date = new Date(Date.now() + new Date().getTimezoneOffset() * 60000);
    const msec = timeInterval * 3600 * 1000;
    date.setTime(date.getTime() + msec);
    const dateString =
      date.getFullYear() +
      '-' +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + date.getDate()).slice(-2) +
      ' ' +
      ('0' + date.getHours()).slice(-2) +
      ':' +
      ('0' + date.getMinutes()).slice(-2);
    return dateString;
  }

  onExecutionCountUpdated(): void {
    const maxExecutionCount = this.formField.executionCounts ?? 0;
    this.onDataEmit(
      ConfigFieldMapping.MAX_EXECUTION_COUNTS,
      maxExecutionCount,
      maxExecutionCount >= 0 && maxExecutionCount <= this.maxExecutionCountValue
    );
  }

  fetchSchedulerVal(event: SchedulerFormat): void {
    this.scheduler = event;
    this.scheduleInfoData.repeatInterval = event.repeatInterval;
    this.scheduleInfoData.timeStamp = this.setupService.getScheduleTimeStamp(event.timeStamp);
    this.scheduleInfoData.isValid = true;
    this.emitScedulerParams();
  }

  emitScedulerParams(): void {
    this.onDataEmit('scheduler', this.scheduleInfoData, this.scheduleInfoData.isValid);
  }
  //eslint-disable-next-line
  onDataEmit(key: string, newValue: any, isValid: boolean): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      key: key,
      newValue: newValue,
      isValid: isValid
    });
  }

  copyvTAURL(): void {
    if (this.srcAgentType === AGENT_MODEL.VTA_TS) {
      this.notificationService.onSuccess('vTA Test link has been copied to clipboard');
    } else {
      this.notificationService.onSuccess('vSPA Test link has been copied to clipboard');
    }
  }

  copyDMZURL(): void {
    this.notificationService.onSuccess('DMZ Test link has been copied to clipboard');
  }

  restoreOtherTabValues(): void {
    this.streamsA2B = cloneDeep(this.restoreAdvancedFieldValues(ConfigFieldMapping.STREAMS_A2B));
    this.streamsB2A = cloneDeep(this.restoreAdvancedFieldValues(ConfigFieldMapping.STREAMS_B2A));
  }

  //eslint-disable-next-line
  restoreAdvancedFieldValues(field: string): any {
    const data = this.otherTabStateHistory('udp.streams.html', field);
    if (data && !isNil(data.value) && data.value !== REMOVED) {
      return data.value;
    }
    return null;
  }

  getAgentURLLabel(): string {
    return this.srcAgentType === AGENT_MODEL.VTA_TS ? 'vTA-TS Test Link' : 'vSPA-SAT-TS Test Link';
  }

  ngOnDestroy(): void {
    this.unsubscribe.complete();
    this.unsubscribe.next();
    if (this.tabsubscription) {
      this.tabsubscription.unsubscribe();
    }
  }
}
